import React from 'react';

const Footer = (props) => (
  <footer className="footer">
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-6 footer-copyright">
          <p className="mb-0">
            Developed by&nbsp;
            <a href="https://garphild.pro" target="_blank">Garphild.pro</a>
          </p>
        </div>
        <div className="col-md-6">
          <p className="pull-right mb-0">
            {/* <i className="fa fa-heart" /> */}
          </p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
